import { createContext } from "react";
import { createContextualCan } from "@casl/react";
import { useOrganization } from "@clerk/clerk-react";

import { defineAbilityFor } from "./authorization/rules";

export const AbilityContext = createContext(defineAbilityFor(null));
export const Can = createContextualCan(AbilityContext.Consumer);

export default function CaslProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { membership } = useOrganization();

  return (
    <AbilityContext.Provider
      value={defineAbilityFor({
        role: membership?.role ?? null,
        locations: membership?.organization.publicMetadata?.locations ?? null,
        isSystemAdminOrg:
          membership?.organization.publicMetadata?.isSystemAdminOrg ?? false,
      })}
    >
      {children}
    </AbilityContext.Provider>
  );
}
